import { useEffect, useState, useRef } from "react";

function ImageHandler(props: any) {
    const [imagePreviewUrl, setImagePreviewUrl]: any = useState(null);
    const fileInputRef: any = useRef(null);

    useEffect(() => {
        if (props.openFilePopup) {
            if (fileInputRef && fileInputRef.current) {
                fileInputRef.current.click();
            }
        }
    }, [props.openFilePopup])

    useEffect(() => {
        if (imagePreviewUrl) {
            props.imageSelected(imagePreviewUrl)
        }
    }, [imagePreviewUrl])


    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = () => {
                setImagePreviewUrl(reader.result);
            };
            reader.readAsDataURL(file);
        } else {
            console.log('File selection cancelled by user.');
        }
    };

    return (
        <div>
            <input
                type="file"
                ref={fileInputRef}
                onChange={handleFileChange}
                accept=".png, .jpg, .jpeg"
                style={{ display: 'none' }}
            />

        </div>
    );
}

export default ImageHandler;